// ══════════════════════════════════════════════════════════════════════════════════════════════
//  t385 · EL DÍA Y EL FILTRO QUE TRAE LA DIRECCIÓN (22-oct-2026)
// ══════════════════════════════════════════════════════════════════════════════════════════════
//
//  EL FALLO (lo vio el dueño): el «Ver» de la tarjeta «citas sin confirmar de MAÑANA» del asistente LucIA abría
//  Recordatorios de HOY. Ni la dirección llevaba el día ni la pantalla lo leía (y la ruta vieja /recordatorios, al pasar a
//  Seguimiento, tira lo que lleve detrás). Ahora cada «Ver» lleva su día o su filtro (backend/services/asistenteLuciaEnlaces.js)
//  y las pantallas de destino lo leen de aquí al abrirse:
//   · Recordatorios  /seguimiento?t=recordatorios &fecha=AAAA-MM-DD &ver=sin_confirmar &doctor=<agenda>
//   · Recalls        /seguimiento?t=recalls &desde= &hasta= &estado=
//   · Recepción      ?fecha=AAAA-MM-DD &filtro=porConfirmar|confirmadas|enClinica|finalizadas|noVino
//   · Caja           ?fecha=AAAA-MM-DD (si no es hoy, su cierre) &sede=<id>; ?vista=cuotas&filtro=vencidas
//   · Informes       ?informe=<id> &desde=AAAA-MM-DD &hasta=AAAA-MM-DD
//   · Mis consentimientos ?dia=AAAA-MM-DD (los de las citas de ese día)
//   · Laboratorio    ?entrega=AAAA-MM-DD (los que llegan ese día) o ?atrasados=1
//  (la Agenda ya leía ?fecha= y ?cita=).
//
//  CON LA PANTALLA YA ABIERTA (el panel de LucIA está al lado y se pulsa otro «Ver»): Seguimiento remonta su pestaña si cambia
//  la huella del enlace; Mis consentimientos y Laboratorio leen la dirección en cada pintado; y la Caja, Recepción, las cuotas e
//  Informes escuchan el aviso que da el panel al navegar (`avisarDelEnlace` / `alCambiarElEnlace`).
//
//  SIN IMPORTS A PROPÓSITO: un `utils/` sin dependencias lo cargan de verdad las guardias que montan una pantalla.
//  Lo que no es un día de verdad (2026-02-30) o un valor de la lista no se aplica: la pantalla abre como siempre.

export const RE_DIA = /^\d{4}-\d{2}-\d{2}$/

export function esDia(v) {
  const s = String(v == null ? '' : v)
  if (!RE_DIA.test(s)) return false
  const [y, m, d] = s.split('-').map(Number)
  if (m < 1 || m > 12 || d < 1) return false
  const bisiesto = (y % 4 === 0 && y % 100 !== 0) || y % 400 === 0
  const dim = [31, bisiesto ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][m - 1]
  return d <= dim
}

// La búsqueda (`?a=1&b=2`) de la ventana de ESTA pantalla; vacía si no la hay (una prueba, el servidor).
export function buscaDe(w) {
  try { return w && w.location && typeof w.location.search === 'string' ? w.location.search : '' } catch { return '' }
}

export function parametro(search, clave) {
  try { const v = new URLSearchParams(String(search || '')).get(clave); return v == null ? null : String(v) } catch { return null }
}

export function diaDeLaUrl(search, clave = 'fecha') {
  const v = parametro(search, clave)
  return v && esDia(v) ? v : null
}

export function opcionDeLaUrl(search, clave, permitidas) {
  const v = parametro(search, clave)
  return v && Array.isArray(permitidas) && permitidas.includes(v) ? v : null
}

export function enteroDeLaUrl(search, clave) {
  const v = parametro(search, clave)
  if (!v || !/^\d{1,12}$/.test(v)) return null
  const n = Number(v)
  return n > 0 ? n : null
}

// «2026-10-23» → «23/10/2026», sin pasar por Date.
export function diaCorto(ymd) {
  return esDia(ymd) ? ymd.slice(8, 10) + '/' + ymd.slice(5, 7) + '/' + ymd.slice(0, 4) : ''
}

// LO QUE PONE UN ENLACE Y NUNCA LA PROPIA PANTALLA: si cambia con la pestaña ya abierta, pages/Seguimiento.jsx la remonta.
export const CLAVES_DEL_ENLACE = ['fecha', 'ver', 'doctor', 'filtro', 'informe', 'desde', 'hasta', 'dia', 'entrega', 'atrasados', 'estado', 'sede', 'avanzado']   // t505 · la petición del Informe avanzado

export function huellaDelEnlace(search) {
  return CLAVES_DEL_ENLACE.map((k) => parametro(search, k) || '').join('|')
}

// EL AVISO DEL PANEL DE LucIA AL NAVEGAR: la pantalla que ya estaba abierta (la misma dirección con otro día o filtro) lo vuelve
// a leer. `alCambiarElEnlace` devuelve la limpieza del efecto; sin ventana (una prueba, el servidor), no hace nada.
export const EVENTO_ENLACE = 'biango:enlace-de-lucia'

export function avisarDelEnlace(w) {
  try { if (w && typeof w.dispatchEvent === 'function' && typeof CustomEvent === 'function') w.dispatchEvent(new CustomEvent(EVENTO_ENLACE)) } catch { /* sin ventana */ }
}

export function alCambiarElEnlace(w, fn) {
  if (!w || typeof w.addEventListener !== 'function' || typeof fn !== 'function') return () => {}
  const h = () => fn(buscaDe(w))
  w.addEventListener(EVENTO_ENLACE, h)
  return () => { try { w.removeEventListener(EVENTO_ENLACE, h) } catch { /* ya no está */ } }
}
